import { render, staticRenderFns } from "./BrandConsent.vue?vue&type=template&id=450cb528"
import script from "./BrandConsent.vue?vue&type=script&lang=ts"
export * from "./BrandConsent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports